import { BusinessCardScanOcrFields, ReferenceContactId } from "@sp-crm/core";

const pending = new Map<ReferenceContactId, BusinessCardScanOcrFields>();

interface OcrFieldsFromWire {
    name?: string | null;
    title?: string | null;
    company?: string | null;
    email?: string | null;
    cellPhone?: string | null;
    phone?: string | null;
    website?: string | null;
    address1?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
}

const normalizeOcrFields = (raw: OcrFieldsFromWire): BusinessCardScanOcrFields => ({
    name: raw.name ?? null,
    title: raw.title ?? null,
    company: raw.company ?? null,
    email: raw.email ?? null,
    cellPhone: raw.cellPhone ?? null,
    phone: raw.phone ?? null,
    website: raw.website ?? null,
    address1: raw.address1 ?? null,
    city: raw.city ?? null,
    state: raw.state ?? null,
    zip: raw.zip ?? null,
});

export const stashOcrFieldsForFeedback = (
    referenceContactId: ReferenceContactId,
    ocrFields: OcrFieldsFromWire,
): void => {
    pending.set(referenceContactId, normalizeOcrFields(ocrFields));
};

export const peekOcrFieldsForFeedback = (
    referenceContactId: ReferenceContactId,
): BusinessCardScanOcrFields | null => {
    return pending.get(referenceContactId) ?? null;
};

export const clearOcrFieldsForFeedback = (
    referenceContactId: ReferenceContactId,
): void => {
    pending.delete(referenceContactId);
};
